"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarDay = void 0;
const react_1 = __importDefault(require("react"));
const Text_1 = require("../Text/Text");
const react_native_1 = require("react-native");
const CalendarDay_style_1 = require("./CalendarDay.style");
function CalendarDay({ children, isDatePassed, hasSlot, isSelected, isDoctorAbsent, onPress, }) {
    return (react_1.default.createElement(react_native_1.View, { style: [CalendarDay_style_1.styles.dayContainer] },
        react_1.default.createElement(react_native_1.Pressable, { onPress: () => hasSlot && onPress(), disabled: isDatePassed || !hasSlot },
            react_1.default.createElement(Text_1.Text, { style: [
                    CalendarDay_style_1.styles.day,
                    isDatePassed ? CalendarDay_style_1.styles.passedDay : {},
                    hasSlot && !isDoctorAbsent ? CalendarDay_style_1.styles.slotDay : {},
                    isSelected && !isDoctorAbsent ? CalendarDay_style_1.styles.selectedDay : {},
                    isSelected && isDoctorAbsent ? CalendarDay_style_1.styles.selectedDayAbsent : {},
                    hasSlot && isDoctorAbsent ? CalendarDay_style_1.styles.doctorAbsent : {},
                ] }, children))));
}
exports.CalendarDay = CalendarDay;
